import { DownloadCheckboxKey } from './common';
import { DownloadInfoItem } from '../types/analytics';

export function downloadCheckboxList() {
  return [
    {
      datasetId: '',
      radioKey: DownloadCheckboxKey.SW,
      options: [],
    },
    {
      datasetId: '',
      radioKey: DownloadCheckboxKey.HD,
      options: [],
    },
    {
      datasetId: '',
      radioKey: DownloadCheckboxKey.Wind,
      options: [],
    },
  ] as DownloadInfoItem[];
}
